import { v } from 'h3-valibot';

export const featureTogglesSchema = v.object({
  useContentPageCache: v.optional(v.boolean(), true),
  showCheckoutCancelSurvey: v.optional(v.boolean(), false),
  useReorderButton: v.optional(v.boolean(), false),
  'usewebappCheckout_de-de': v.boolean(),
  'usewebappCheckout_it-it': v.boolean(),
  'usewebappCheckout_fr-fr': v.boolean(),
  'usewebappCheckout_ko-kr': v.boolean(),
  usewebappCheckout_en: v.boolean(),
  'usewebappCheckout_en-in': v.boolean(),
  'usewebappCheckout_en-us': v.boolean(),
  'usewebappCheckout_en-sg': v.boolean(),
  'usewebappCheckout_ru-ru': v.boolean(),
  'usewebappCheckout_ja-jp': v.boolean(),
  'usewebappCheckout_zh-tw': v.boolean(),
  'usewebappCheckout_zh-cn': v.boolean(),
  useImageVisualizationService: v.optional(v.boolean(), false),
  showLensFinderOnPDP: v.optional(v.boolean(), false),
  shippingTextAsPlainText: v.optional(v.array(v.string()), []),
  /**
   * Locales (webapp locale codes, e.g. `ko-kr`) for which the order-sum tax
   * hint (`cart.label.ordersum.hint`) is rendered in the cart checkout summary.
   * Empty by default — the hint stays hidden unless the current locale is listed.
   */
  showTaxHintInCartCheckout: v.optional(v.array(v.string()), []),
  useKlarnaB2b: v.optional(v.boolean(), false),
  useTrustBox: v.optional(v.boolean(), false),
  /**
   * Locales for which the Non-Binding Quote (NBQ / Angebots-PDF) feature is
   * active. Pilot: ["en-us"]. Extend the array to roll out to more regions.
   */
  useNBQOption: v.optional(v.array(v.string()), []),
  /**
   * Locales for which the floating contact button is shown when a
   * `floatingContactButton` entry is linked in
   * `additionalConfiguration` on global page settings (e.g. ["zh-cn"]).
   */
  showFloatingContactButton: v.optional(v.array(v.string()), []),
  /**
   * Locales for which the header top bar is shown when a `headerTopBar`
   * entry is linked in `additionalConfiguration` (e.g. ["de-de", "fr-fr"]).
   */
  showHeaderTopBar: v.optional(v.array(v.string()), []),
  /**
   * Locales for which the customer onboarding modal is shown after login
   * (webapp locale codes, e.g. ["en", "de-de"]). Empty by default — the modal
   * stays hidden unless the current locale is listed.
   */
  showOnboardingModal: v.optional(v.array(v.string()), []),
  /**
   * Locales for which the Action Bar shows cross-sell product add-ons after
   * add-to-cart (webapp locale codes, e.g. ["de-de"]). Empty by default.
   */
  showProductAddOnsInActionBar: v.optional(v.array(v.string()), []),
  /**
   * Locales for which the BVS image rendering is offered on camera PDPs.
   * Empty by default so the simulation stays hidden unless explicitly enabled.
   */
  showBvsImageRendering: v.optional(v.array(v.string()), []),
  /**
   * Locales for which the guest-checkout ghost button is shown on cart
   * checkout (webapp locale codes, e.g. ["de-de"]). Empty / missing → hidden.
   */
  showGuestCartCheckoutButton: v.optional(v.array(v.string()), []),
  categorySelectorItems: v.optional(
    v.object({
      lens: v.optional(v.boolean(), false),
      camera: v.optional(v.boolean(), false),
      framegrabber: v.optional(v.boolean(), false),
      illumination: v.optional(v.boolean(), false)
    })
  )
});

export type FeatureToggles = v.InferOutput<typeof featureTogglesSchema>;
